import { useEffect, useState } from "react";
import { EVENT_DATE } from "../../config/event";

const remaining = (target) => {
  const ms = Math.max(0, target.getTime() - Date.now());
  const s = Math.floor(ms / 1000);
  return { days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), min: Math.floor((s % 3600) / 60), sec: s % 60 };
};

export const pad = (n) => String(n).padStart(2, "0");

export const useCountdown = (target) => {
  const [t, setT] = useState(() => remaining(target));
  useEffect(() => {
    const id = setInterval(() => setT(remaining(target)), 1000);
    return () => clearInterval(id);
  }, [target]);
  return t;
};

const UNITS = [["days", "Days"], ["hours", "Hours"], ["min", "Min"], ["sec", "Sec"]];

export const Countdown = ({ target = EVENT_DATE, className = "" }) => {
  const t = useCountdown(target);
  return (
    <div className={`grid w-full max-w-md grid-cols-4 gap-2 sm:gap-3 ${className}`} data-testid="countdown" role="timer" aria-label="Time until the masterclass">
      {UNITS.map(([key, label]) => (
        <div key={key} className="lacquer rounded-xl px-1 py-3 text-center sm:py-4" data-testid={`countdown-${key}`}>
          <div className="font-display gold-text text-4xl leading-none tabular-nums sm:text-5xl" data-testid={`countdown-${key}-value`}>{pad(t[key])}</div>
          <div className="font-mono-plex mt-2 text-[10px] uppercase tracking-[0.22em] text-[#bdb4a2]">{label}</div>
        </div>
      ))}
    </div>
  );
};
